// extracted by mini-css-extract-plugin
module.exports = {"body":"cohortpromogeneral_body__J8dFs","column":"cohortpromogeneral_column__7_Vw7"};